import { useEffect, useRef } from "react";

import PageSeo from "@/components/PageSeo";
import ChecklistSection from "@/components/sections/ChecklistSection";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import FaqSection from "@/components/sections/FaqSection";
import HeroSection from "@/components/sections/HeroSection";
import IconCardGridSection from "@/components/sections/IconCardGridSection";
import PricingSection from "@/components/sections/PricingSection";
import ProfileSection from "@/components/sections/ProfileSection";
import StatementSection from "@/components/sections/StatementSection";
import { workshopPageContent } from "@/content/pages/workshopPage";
import { trackWorkshopViewContent } from "@/lib/conversionTracking";

const WorkshopPage = () => {
  const hasTrackedViewContent = useRef(false);

  useEffect(() => {
    if (hasTrackedViewContent.current) {
      return;
    }

    hasTrackedViewContent.current = true;
    trackWorkshopViewContent();
  }, []);

  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={workshopPageContent.seo} />
      <HeroSection content={workshopPageContent.hero} dataTestId="workshop-hero" />
      <IconCardGridSection
        content={workshopPageContent.audienceSection}
        variant="audience"
        className="bg-muted/50"
        dataTestId="workshop-audience"
      />
      <StatementSection content={workshopPageContent.problemSection} dataTestId="workshop-problem" />
      <ChecklistSection
        content={workshopPageContent.outcomesSection}
        sectionId="outcomes"
        dataTestId="workshop-outcomes"
      />
      <IconCardGridSection
        content={workshopPageContent.curriculumSection}
        variant="curriculum"
        sectionId="curriculum"
        dataTestId="workshop-curriculum"
      />
      <IconCardGridSection
        content={workshopPageContent.formatSection}
        variant="format"
        className="bg-muted/50"
        dataTestId="workshop-format"
      />
      <IconCardGridSection
        content={workshopPageContent.examplesSection}
        variant="examples"
        dataTestId="workshop-examples"
      />
      <ProfileSection content={workshopPageContent.instructorSection} dataTestId="workshop-instructor" />
      <PricingSection content={workshopPageContent.pricingSection} dataTestId="workshop-pricing" />
      <FaqSection content={workshopPageContent.faqSection} dataTestId="workshop-faq" />
      <CtaBannerSection content={workshopPageContent.finalCta} dataTestId="workshop-final-cta" />
    </div>
  );
};

export default WorkshopPage;
